import React from 'react'

import 'bootstrap/dist/css/bootstrap.min.css'

import { Link } from 'react-router-dom'

const FullstackCard = () => {
  return (
    <div className="card w-25 h-auto">
        <div className="card-body bg-dark text-white">
          <h5 className="card-title">MERN Fullstack</h5>
          <p className="card-text">
          Certified MERN Fulstack developer by the MIT.
          Application development using MongoDB, Express, React and Node.js oriented to
          IIOT.
          </p>
          <Link href="#" className="btn btn-light" to="/fullstack">
            Look at my Apps!!!
          </Link>
        </div>
      </div>
  )
}

export default FullstackCard;